import { render, staticRenderFns } from "./event-summary.vue?vue&type=template&id=29239613"
import script from "./event-summary.vue?vue&type=script&lang=js"
export * from "./event-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29239613')) {
      api.createRecord('29239613', component.options)
    } else {
      api.reload('29239613', component.options)
    }
    module.hot.accept("./event-summary.vue?vue&type=template&id=29239613", function () {
      api.rerender('29239613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event-summary.vue"
export default component.exports